<template>
    <div class="page m-trainSpecial">
        <div class="page-table">
            <div class="page-operate">
                <el-tooltip class="item" effect="dark" :content="$t('system.addMenu')" placement="top-start"
                            :hide-after="1000">
                    <el-button size="small" @click="addSpecial(0)"><i class="nucfont inuc-add"></i></el-button>
                </el-tooltip>
            </div>

            <data-tables class="form-table"
                         :data="specialData"
                         :table-props="tableProps"
                         :current-page="1"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                         v-viewer
            >
                <el-table-column prop="value" label="专题名称" align="center"></el-table-column>
                <el-table-column prop="coverURL" label="封面" align="center" min-width="200">
                    <template #default="{row}">
                        <img v-if="row.coverURL" class="cover-img" :src="row.coverURL" alt="cover">
                        <div v-else class="cover-empty">暂无封面</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="序号" width="80" align="center" sortable="custom"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="200" align="center"
                                 sortable="custom"></el-table-column>
                <el-table-column prop="modifyTime" label="修改时间" width="200" align="center"
                                 sortable="custom"></el-table-column>
                <el-table-column prop="remark" label="备注" align="left"></el-table-column>
                <el-table-column :label="$t('c.operation')" align="center">
                    <template #default="{row}">
                        <div class="btn-cell">
                            <i class="nucfont inuc-edit" :title="$t('c.edit')" @click="addSpecial(row.id)"></i>
                            <i class="nucfont inuc-delete" :title="$t('c.delete')" @click="deleteSpecial(row.id)"></i>
                        </div>
                    </template>
                </el-table-column>
            </data-tables>
        </div>

        <el-dialog
            :title="specialDialogTitle"
            :visible.sync="specialDialog"
            top="10vh"
            custom-class="special-dialog"
            width="750px"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
        >
            <el-form :model="form"
                     :rules="rules"
                     class="special-form"
                     ref="specialForm"
                     label-width="120px"
                     @submit.native.prevent
            >
                <el-form-item label="专题名称" prop="value">
                    <el-input v-model="form.value" :placeholder="$t('tip.name')"
                              clearable
                              maxlength="10"
                              show-word-limit
                              style="width: 266px;"
                    ></el-input>
                </el-form-item>
                <el-form-item label="专题封面" prop="coverURL">
                    <div class="cover-wrap">
                        <el-popover
                            placement="bottom"
                            width="1120"
                            trigger="click"
                            v-if="!form.coverURL"
                        >
                            <ul class="special-cover-list">
                                <li class="cover-item" v-for="url in coverList" :key="url" @click="chooseImage(url)">
                                    <img class="cover-item-img" :src="url" alt="cover">
                                </li>
                            </ul>
                            <div class="cover-default" slot="reference">
                                <div class="prepare-content">
                                    <h5>选择预置封面</h5>
                                    <p class="tip">从给定的图片中选择</p>
                                </div>
                            </div>
                        </el-popover>

                        <!--                        <div class="cover-default" v-if="!form.coverURL">-->
                        <!--                            <div class="prepare-content">-->
                        <!--                                <h5>选择预置封面</h5>-->
                        <!--                                <p class="tip">从给定的图片中选择</p>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <image-uploader class="cover-upload" v-model="form.coverURL" @on-success="uploadSuccess">
                            <template #prepare>
                                <div class="prepare-content">
                                    <h5>自定义封面</h5>
                                    <p class="tip">上传本地图片，最佳比例16:9</p>
                                </div>
                            </template>
                        </image-uploader>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('c.NO')" prop="sort">
                    <el-input-number v-model="form.sort" controls-position="right" :min="0" :precision="0" :max="50"></el-input-number>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="form.remark"
                              :autosize="{minRows:3,maxRows:4}"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align: center;margin-bottom: 10px">
                <el-button type="primary" @click="saveForm" :loading="saveLoading">{{ $t('c.save') }}</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import ImageUploader from "@components/UI/ImageUploaderz";

export default {
    components: {
        ImageUploader
    },

    data() {
        return {
            specialData: [],
            tableProps: {
                border: false,
                stripe: true,
                height: 'auto'
            },
            specialDialog: false,
            currentId: '',
            form: {
                value: '',
                coverURL: '',
                sort: 0,
                remark: ''
            },
            rules: {
                value: [
                    {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                    // {max: 10, message: this.$t('rule.maxLength', ['10']), trigger: 'blur'}
                ],
                coverURL: [
                    {required: true, message: '请选择或上传专题封面！'},
                ],
                remark: [
                    {max: 200, message: this.$t('rule.maxLength', ['200']), trigger: 'blur'},
                ],
            },
            saveLoading: false,
            coverList: []
        }
    },

    computed: {
        specialDialogTitle() {
            return this.currentId ? '编辑培训专题' : '添加培训专题'
        }
    },

    mounted() {
        this.getTableData()
        this.getCoverList()
    },

    methods: {
        getTableData() {
            this.$api.getTrainSpecial().then(res => {
                this.specialData = res.package.map(item => {
                    item.modifyTime = item.modifyTime || ''
                    return item
                })
            })
        },

        getCoverList() {
            this.$api.getTrainSpecialCover().then(res => {
                this.coverList = res.package.map(item => item.value)
            })
        },

        chooseImage(url) {
            this.form.coverURL = url
            this.$refs.specialForm.validateField('coverURL')
        },

        uploadSuccess() {
            this.$refs.specialForm.validateField('coverURL')
        },

        addSpecial(id) {
            this.currentId = id
            this.specialDialog = true
            this.$refs.specialForm?.resetFields()

            this.$nextTick(() => {
                if (this.currentId) {
                    let data = this.specialData.find(ele => ele.id === this.currentId);
                    for (let item in data) {
                        if (this.form.hasOwnProperty(item)) {
                            this.form[item] = data[item]
                        }
                    }
                }
            })
        },

        async deleteSpecial(id) {
            try {
                await this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {type: 'warning'})
                await this.$api.deleteTrainSpecial(id)
                this.$message.success(this.$t('m.delSuccess'))
                this.getTableData()
            } catch (e) {}
        },

        saveForm() {
            this.$refs['specialForm'].validate((valid) => {
                if (!valid) return;
                this.saveLoading = true;

                //修改
                if (this.currentId) {
                    this.$api.editTrainSpecial(this.currentId, this.form).then(res => {
                        this.specialDialog = false
                        this.$message.success(this.$t('m.editSuccess'))
                        this.getTableData()
                    }).finally(() => this.saveLoading = false)
                } else {
                    this.$api.postTrainSpecial(this.form).then(res => {
                        this.specialDialog = false
                        this.$message.success(this.$t('m.addSuccess'))
                        this.getTableData()
                    }).finally(() => this.saveLoading = false)
                }
            })
        },
    },
}
</script>

<style scoped lang="scss">
$img-width: 266px;
$img-height: 150px;

.form-table {
    /deep/ {
        td {
            padding: 10px 0;
        }
    }
}

.cover-img {
    width: $img-width;
    height: $img-height;
    object-fit: cover;
    cursor: pointer;
}

.cover-empty {
    width: $img-width;
    height: $img-height;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ebeef3;
    color: #c0c4cc;
}

.special-form {
    margin-right: 40px;
}

.image-uploader {
    /deep/ .image-uploader-file {
        object-fit: cover;
    }
}

.cover-wrap {
    display: flex;
    line-height: 1.6;
    text-align: center;

    .prepare-content {
        width: 100%;
    }

    .cover-default {
        display: flex;
        align-items: center;
        justify-content: center;
        width: $img-width;
        height: $img-height;
        margin-right: 15px;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;

        &:hover {
            border-color: $blue;
            color: $blue;
        }
    }

    .cover-upload {
        width: $img-width;
        height: $img-height;

        /deep/ {
            .el-upload,
            .el-image-uploader {
                width: 100%;
                height: 100%;
                line-height: 1.6;
            }
        }
    }

    .tip {
        margin-top: 10px;
        font-size: 12px;
        color: #999;
    }
}

.special-cover-list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .cover-item {
        padding: 1px;
    }

    .cover-item-img {
        width: $img-width;
        height: $img-height;
        cursor: pointer;
        border: 1px solid transparent;
        transition: all .15s;
        object-fit: cover;
        &:hover {
            border-color: $blue;
            filter: brightness(1.1);
        }
    }
}
</style>
